// Globals
import React, { useCallback, useState } from 'react';
import { Auth } from 'aws-amplify';

// UI
import { Button, Flex, Form, message } from 'antd';

// Locals
import styles from './Account.module.css';
import CardFormInput from '../CardForms/CardFormInput';

// Types

const AccountPassword: React.FC = () => {
  const [passwordForm] = Form.useForm();
  const [editing, setEditing] = useState<boolean>(false);

  const cleanState = useCallback(async () => {
    await passwordForm.resetFields();
    setEditing(false);
  }, [passwordForm]);

  const handlePasswordChange = useCallback(async () => {
    const formData = await passwordForm.validateFields().catch(_ => {
      console.error('Failed to validate fields');
    });
    if (formData) {
      if (formData.oldPassword === formData.newPassword) {
        message.error('New password cannot be same as old password');
      } else {
        Auth.currentAuthenticatedUser()
          .then(user => {
            return Auth.changePassword(
              user,
              formData.oldPassword,
              formData.newPassword
            );
          })
          .then(data => {
            if (data === 'SUCCESS') {
              message.success('Password successfully changed');
              cleanState();
            }
          })
          .catch(err => {
            if (err.code === 'NotAuthorizedException') {
              message.error('Incorrect old password');
            } else {
              message.error('Password change failed');
            }
          });
      }
    }
  }, [passwordForm, cleanState]);

  return (
    <div className={styles.password}>
      {!editing ? (
        <Flex gap={'middle'} align={'center'}>
          <span>**********</span>
          <Button type={'default'} onClick={() => setEditing(true)}>
            Edit
          </Button>
        </Flex>
      ) : (
        <>
          <Form
            layout="vertical"
            requiredMark={true}
            autoComplete="off"
            form={passwordForm}
          >
            <CardFormInput
              name="oldPassword"
              fieldLabel="Old Password"
              placeholder="Old Password"
              type="password"
              validatePassword={false}
            />
            <CardFormInput
              name="newPassword"
              errorName={'new password'}
              fieldLabel="New Password"
              minLength={8}
              maxLength={20}
              placeholder="New Password"
              type="password"
              hasFeedback={true}
            />
            <CardFormInput
              name="newPasswordConfirmation"
              errorName={'new password confirmation'}
              fieldLabel="New Password Confirmation"
              minLength={8}
              maxLength={20}
              placeholder="New Password Confirmation"
              type="password"
              passwordConfirmation={true}
              hasFeedback={true}
            />
          </Form>
          <Flex justify={'flex-end'} gap={'middle'}>
            <Button onClick={() => cleanState()}>Cancel</Button>
            <Button type={'primary'} onClick={() => handlePasswordChange()}>
              Save changes
            </Button>
          </Flex>
        </>
      )}
    </div>
  );
};

export default AccountPassword;
